{
  "version": 1,
  "asset_id": "8322cec3-0f6c-4ed9-ad6f-e69cd50dfd5c",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/8322cec3-0f6c-4ed9-ad6f-e69cd50dfd5c/buyukcekmece-isyeri-3.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/8322cec3-0f6c-4ed9-ad6f-e69cd50dfd5c/buyukcekmece-isyeri-3.jpg",
  "original_filename": "buyukcekmece-isyeri-3.jpg",
  "size": 669551,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T07:24:15Z"
}
